<template>
  <div class="reschedule-main-view width-responsiveness">
    <subheader class="alternative-subheader alternative-subheader__limit-width">
      <div
        slot="filter-labels"
        class="search-title"
      >
        <md-icon
          md-src="/static/images/icon-turn-back.svg"
          @click.native="$router.push('/dashboard')"
        />
        <h2>
          <span>Listagem de remarcação</span>
          <span
            v-if="$route.query.orderId"
            class="filter-labels"
          >filtrado por OS Álvaro {{ $route.query.orderId
          }}</span>
        </h2>
      </div>

      <div class="subheader-alternative-actions-container">
        <div
          class="subheader-actions-container__turn-back position-right"
          @click="$router.push('/reschedule/filter')"
        >
          <md-icon
            id="backToSearch"
            md-src="/static/images/icon-back-to-search.svg"
          />
        </div>
      </div>
    </subheader>

    <div class="reschedule-main-view__left-side">
      <card
        title="Remarcação"
        :subtitle-regular="timeAgo.phrase"
        :subtitle-highlight="timeAgo.time"
      >
        <count-icon
          v-if="!isRescheduleListStatusLoading"
          :content="{
            number: rescheduleList.length,
            text: 'resultados reagendados',
            color: 'orange',
            icon: 'dashboard-calendar'
          }"
        />
        <spinner v-else />
      </card>
    </div>

    <div class="reschedule-main-view__middle-side">
      <reschedule-data-table />
    </div>
  </div>
</template>

<script>
import CountIndicator from '@/components/Dashboard/Widgets/CountIndicator'
import CountIcon from '../common/dataTable/CountIcon'
import Card from '@/components/Dashboard/Card'
import SubHeader from '../common/SubHeader'
import comboBox from '../common/ComboBox'
import RescheduleDataTable from './RescheduleDataTable'
import Spinner from '../common/Spinner'
import { DASHBOARD_INTERVAL_TIME_STAMP_MILISECONDS } from '@/enums'
import Moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RescheduleMainView',
  components: {
    'count-indicator': CountIndicator,
    'count-icon': CountIcon,
    card: Card,
    subheader: SubHeader,
    'combo-box': comboBox,
    'reschedule-data-table': RescheduleDataTable,
    spinner: Spinner
  },
  data() {
    return {
      orderBy: null,
      interval: null,
      minutes: 0,
      updateTime: new Date(),
      options: [
        { value: 'createdAt', label: 'Data da Recoleta' },
        { value: 'os', label: 'OS Alvaro' }
      ]
    }
  },
  computed: {
    ...mapGetters(['isRescheduleListStatusLoading', 'rescheduleList']),
    searchParam: function () {
      return this.$router.history.current.query.typeOfSearch
    },
    searchQuery: function () {
      return this.$router.history.current.query.q
    },
    timeAgo() {
      if (this.minutes === 0) {
        return { phrase: 'atualizado', time: 'agora' }
      } else {
        return { phrase: 'atualizado há', time: this.minutes + ' min' }
      }
    }
  },
  watch: {
    $route(to, from) {
      this.getInitialFilters()
    },
    orderBy: function (newValue) {
      let params = JSON.parse(JSON.stringify(this.$route.query))
      params.orderByProperty = newValue.value
      this.redirect(params)
    }
  },
  created() {
    this.getInitialFilters()
    this.updateTimeAgo()
  },
  beforeDestroy() {
    this.clearAllRescheduleData()
    clearInterval(this.interval)
  },
  methods: {
    ...mapActions(['selectRescheduleParams', 'clearAllRescheduleData']),
    updateTimeAgo() {
      this.interval = setInterval(
        function () {
          this.calculateTimeAgo()
        }.bind(this),
        DASHBOARD_INTERVAL_TIME_STAMP_MILISECONDS
      )
    },
    calculateTimeAgo() {
      let now = new Date()
      let milliseconds = Math.abs(this.updateTime.getTime() - now.getTime())
      this.minutes = Moment(milliseconds).minutes()
    },
    getFilterDefault() {
      this.$router.push({
        path: this.$route.path
      })
    },
    getInitialFilters() {
      if (this.$route.query.orderId) {
        this.clearAllRescheduleData()
        this.selectRescheduleParams(this.$router.history.current.query)
      } else {
        this.getFilterDefault()
      }
    },
    redirect(params) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, params)
      })
    }
  }
}
</script>

<style lang="scss">
@import "../../../static/stylesheets/variables";

.reschedule-main-view {
  height: 100vh;
  padding-top: 58px !important;
  margin-top: 3em;
  display: flex;
  flex-direction: row;

  .combo-container .combo-box {
    width: 11em;
    text-align: left;
  }

  .loader-table {
    margin-top: 20%;
    margin-left: 57%;
  }

  .empty-search {
    width: 20%;
    position: relative;
    top: 35%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: auto;

    .md-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 1em;
      margin-left: 35%;
    }

    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #7a7a7a;
    }
  }

  .search-title {
    display: flex;

    .md-icon {
      cursor: pointer;
      margin-right: 0.7em;
    }
  }

  .subheader__content__right-side {
    display: flex;

    .subheader-alternative-actions-container {
      position: inherit;
    }

    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #7a7a7a;
      margin: auto;
    }
  }

  &__left-side {
    width: 20%;
    margin-top: 3em;

    .md-card {
      margin-top: 4.3em;
      height: 120px;
      background: #fff no-repeat scroll;

      .count-icon__icon .md-icon {
        padding: 0;
        margin-right: 0.5em;
        height: 27px;
      }

      .loader {
        width: 50px;
        height: 50px;
        margin-top: 1em;
      }
    }
  }

  &__middle-side {
    margin-left: 2em;
    width: 78%;
    margin-top: 2em;

    h2 {
      font-size: 22px;
      font-weight: 400;
      letter-spacing: -0.3px;
      text-align: left;
      color: #7a7a7a;
      line-height: 1.09;
    }

    .btn-small {
      letter-spacing: 1px;
    }
  }
}
</style>
